export default __webpack_public_path__ + "static/media/PSMP.f3623558.jpg";